var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 169,
    height: 78,
    viewBox: "0 0 169 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M158.773 76.9327C164.41 76.9327 168.98 72.3631 168.98 66.7261C168.98 61.0892 164.41 56.5195 158.773 56.5195C153.136 56.5195 148.566 61.0892 148.566 66.7261C148.566 72.3631 153.136 76.9327 158.773 76.9327Z",
    fill: "#1C1C1C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0662 0.140625C13.2887 4.13492 0 20.0065 0 38.9938C0 57.9811 13.2887 73.8527 31.0662 77.847C29.5059 75.9459 28.5698 73.5119 28.5698 70.8618V7.12584C28.565 4.47578 29.5059 2.04176 31.0662 0.140625Z",
    fill: "#1C1C1C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9883 0C49.6206 1.92034 50.6096 4.40717 50.6096 7.12445V70.8604C50.6096 73.5777 49.6206 76.0645 47.9883 77.9848C66.073 74.221 79.6642 58.1958 79.6642 38.9924C79.6642 19.7891 66.073 3.76386 47.9883 0Z",
    fill: "#1C1C1C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0625 15.7852V37.2881L106.231 15.7852H86.0625Z",
    fill: "#1C1C1C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1367 77.1639H108.296L139.367 15.7852H115.925L85.1367 77.1639Z",
    fill: "#1C1C1C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M139.872 77.1632V55.7227L117.898 77.1632H139.872Z",
    fill: "#1C1C1C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlack);
export default __webpack_public_path__ + "static/media/LogoBlack.cfaef6c79267fe94900bbac6ca85e4e5.svg";
export { ForwardRef as ReactComponent };